export const SERVICE_UNAVAILABLE_EVENT = "webprofit:service-unavailable";

const RETRYABLE_GATEWAY_STATUSES = new Set([502, 503, 504]);

export function isServiceUnavailableError(error) {
  if (!error || error?.code === "ERR_CANCELED") return false;

  const status = Number(error?.response?.status || 0);
  if (RETRYABLE_GATEWAY_STATUSES.has(status)) return true;

  if (error?.response) return false;

  const code = String(error?.code || "").toUpperCase();
  const message = String(error?.message || "").toLowerCase();
  return (
    code === "ERR_NETWORK" ||
    message.includes("network error") ||
    message.includes("failed to fetch") ||
    message.includes("load failed")
  );
}

export function notifyServiceUnavailable(error) {
  if (typeof window === "undefined" || !isServiceUnavailableError(error)) return false;

  window.dispatchEvent(
    new CustomEvent(SERVICE_UNAVAILABLE_EVENT, {
      detail: {
        status: Number(error?.response?.status || 0),
        code: String(error?.code || ""),
        at: Date.now(),
      },
    }),
  );
  return true;
}

export function healthUrlFromApiBase(baseUrl) {
  const raw = String(baseUrl || "/api").trim() || "/api";
  try {
    const origin = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const parsed = new URL(raw, origin);
    parsed.pathname = parsed.pathname.replace(/\/api\/?$/i, "") || "/";
    parsed.pathname = `${parsed.pathname.replace(/\/+$/, "")}/health`.replace(/\/{2,}/g, "/");
    parsed.search = "";
    parsed.hash = "";
    return parsed.origin === origin ? `${parsed.pathname}${parsed.search}` : parsed.toString();
  } catch {
    return "/health";
  }
}
